import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { appliquerTheme, suivreSysteme } from './theme';

// Avant le premier rendu : sinon la page s'affiche en sombre le temps d'un
// clignement avant de passer au clair.
appliquerTheme();
suivreSysteme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
